import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Grid, Button } from "@material-ui/core";
import {
    Menu,
    Close,
    FindInPage,
    Delete,
} from '@material-ui/icons';
import { getAdmins } from '../../logic/APIHandler';

import Sidebar from '../../components/Sidebar_Com';
import Table from '../../components/Table_Com';
import TableV2 from '../../components/Table_Com_V2';
import StatusModal from '../../components/Modal_Com';
import Spinner from '../../components/Loading_Com';

class Admin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            open: false,
            openJWT: false,
            adminId: '00000000',
            adminName: '',
            isLoading: false,
            isSidebarOpen: 'slide-out',
            search: localStorage.getItem('search') || '',
            totalData: 0,
            params: null,
        }
        this.windowWidth = window.innerWidth;
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    columns = [
        { 
            title: "Nama", 
            field: "name",
            tooltip: "Nama admin",
            width: 80,
            cellStyle: {
                width: "150px",
                maxWidth: "150px"
            },
        },
        {
            title: "Jenis Admin",
            field: "level",
            tooltip: "Jenis admin",
        },
        {
            title: "Email",
            field: "email",
            tooltip: "Email admin",
        },
    ];

    actions = [
        {
            icon: () => <FindInPage />,
            tooltip: "Lihat Detail Admin",
            onClick: (_, rowData) => {
                this.props.history.push({
                    pathname: "/admin-detail/" + rowData._id,
                });
            },
        },
        {
            icon: () => <Delete />,
            tooltip: "Hapus Admin",
            onClick: (_, rowData) => {
                this.handleOpen(rowData);
            },
        },
    ];

    // Show delete admin modal
    handleOpen(admin) {
        this.setState({
            open: true,
            adminId: admin._id,
            adminName: admin.name,
        })
    }

    // CLose delete admin modal
    handleClose() {
        this.setState({
            open: false,
        })
    }

    // Toggle sidebar menu in responsive
    toggleSidebar() {
        if ( this.state.isSidebarOpen === 'slide-out' ) {
            this.setState({
                isSidebarOpen: 'slide-in',
            });
        }
        else {
            this.setState({
                isSidebarOpen: 'slide-out',
            });
        }
    }

    async getData(params) {
        this.setState({ isLoading: true });
        const page = this.props.match.params ? (Number(this.props.match.params.page) + 1) : 1;
        const payload = {
            page: params && params.page ? params.page :  page,
            sortBy: params && params.sortBy ? params.sortBy : localStorage.getItem('sortBy') ? localStorage.getItem('sortBy') : 'created_at',
            sort: params && params.sort ? params.sort : localStorage.getItem('sort') ? localStorage.getItem('sort') :  'asc',
            ...this.state.search && { search: this.state.search },
        };

        this.setState({ params: payload });
        localStorage.setItem('sortBy', payload.sortBy);
        localStorage.setItem('sort', payload.sort);

        let resp = await getAdmins(payload, false);
        if ( resp[0] && resp[0].status === 200 ) {
            const filteredData = resp[0].data.datas.filter(res => res.level !== "master");
            this.setState({
                data: filteredData,
                isLoading: false,
                totalData: resp[0].data.total,
            });
        }
        else if ( resp[1] && resp[1].status === 401) {
            this.setState({
                openJWT: true,
                isLoading: false,
            });
        }
        else {
            this.setState({ isLoading: false });
        }
    };

    componentDidMount() {
        this.getData();
    };

    componentDidUpdate(_, prevState) {
        setTimeout(() => {
            if (this.state.search.length > 0 && (
              this.state.search.substring(0, this.state.search.length - 1) === prevState.search || prevState.search.substring(0, prevState.search.length - 1) === this.state.search
            )) {
                const search = this.state.search.toLowerCase();
                localStorage.setItem('search', search);
                this.props.history.push({ pathname: '/admin/0' });
                this.getData({ search: '', page: 1 });
            } else if (this.state.search.length === 0 && prevState.search) {
                this.props.history.push({ pathname: '/admin/0' });
                this.getData({ search: '', page: 1 });
            }
          }, 700);
    };

    render() {
        return (
            <div className="content">
                { this.state.isLoading ? ( <Spinner /> ) : "" }
                <Sidebar sidebarState={(this.windowWidth < 768)? this.state.isSidebarOpen : ""} />

                <StatusModal
                    open={this.state.open}
                    onClose={this.handleClose}
                    onClickCancel={this.handleClose}
                    modalType="delete-admin"
                    id={this.state.adminId}
                    color="primary"
                    modalTitle="Hapus admin?"
                    dataName={this.state.adminName}
                    submitText="Delete"
                    cancelText="Cancel"
                    successText="Berhasil menghapus admin!"
                    errorText="Gagal menghapus admin!"
                />
                <StatusModal
                    open={this.state.openJWT}
                    modalType="handle-jwt"
                    modalTitle="Token Anda Sudah Expire"
                />

                <Grid container className="responsive-header">
                    <Grid item xs={6}>
                        <h2>IDEPRENEURS</h2>
                    </Grid>
                    <Grid item xs={6} className="menu-icon-btn">
                        <Button variant="outlined" onClick={this.toggleSidebar}>
                            {this.state.isSidebarOpen === 'slide-out'? <Menu /> : <Close />}
                        </Button>
                    </Grid>
                </Grid>

                <Grid container className="grid-container">
                    <TableV2
                        title="Tabel Admin"
                        path="/admin"
                        columns={this.columns}
                        actions={this.actions}
                        data={this.state.data}
                        total={this.state.totalData}
                        search={this.state.search}
                        setSearch={val => this.setState({ search: val })}
                        refetchTableData={params => this.getData(params)}
                        params={this.state.params}
                    />
                </Grid>
            </div>
        );
    }
}

export default Admin;